import React, { Fragment, useState } from "react";
import { useContextSelector } from "use-context-selector";
import { isNumber } from "lodash";
import BetSlipContext from "../../../context/BetSlipContext";
import { formatWithCommas } from "../../../Utils/Toast";
import useScrollToItem from "../../../component/Scroll";
import RenderOddsSky from "./RenderOddsSky";
import BetSlipSky from "./BetSlipSky";
import useSelectionLogic from "../../useLogic/useSelectionLogic";

const SelectionSky = ({
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  position,
  typeGame,
  user,
  marketId,
  totalMatched,
}) => {
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });

  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const [showLimit, setShowLimit] = useState(false);
  const [localLimit, setLocalLimit] = useState({});
  const scrollToItem = useScrollToItem("#header"); // Pass header selector
  const { handelChange, checkArrays } = useSelectionLogic({
    user: user,
    profileData: profileData,
    detail: detail,
    typeGame: typeGame,
    marketId: marketId,
    totalMatched: totalMatched,
    setLocalLimit,
    scrollToItem,
    localLimit,
    marketName,
  });
  return (
    <div
      id="marketBetsWrap"
      className={`bets-wrap asiahadicap ${ms != 1 ? "disabled" : ""} `}
    >
      <div
        id="minMaxBox"
        className="limit_info-popup"
        style={{ display: showLimit ? "flex" : "none" }}
      >
        <div
          onClick={(e) => {
            e.preventDefault();
            setShowLimit(false);
          }}
          className="close"
        >
          Close
        </div>
        <dl>
          <dt id="minMaxDt">Min / Max</dt>
          <dd id="minMaxInfo">
            {formatWithCommas(localLimit?.minAmount)}/
            {formatWithCommas(localLimit?.maxAmount)}
          </dd>
        </dl>
      </div>
      <div
        onClick={(e) => {
          e.preventDefault();
          setShowLimit(true);
        }}
        id="minMaxButton"
        className="bet-limit"
      />
      <dl id="betsHead" className="bets-selections-head">
        <dt>
          <div
            onClick={(e) => {
              e.preventDefault();
            }}
            className="a-depth"
            id="marketDepthBtn"
          >
            Markets Depth
          </div>
          <p>
            <span>Matched</span>
            <strong id="totalMatched">
              PTH {formatWithCommas(totalMatched)}
            </strong>
          </p>
        </dt>
        <dd className="mode-land" />
        <dd className="mode-land" />
        <dd>Back</dd>
        <dd>Lay</dd>
        <dd className="mode-land" />
        <dd className="mode-land" />
      </dl>
      {runner?.map((item, index) => {
        const odds_back = backOdds?.filter(
          (todd) => todd.ri === item.SelectionId
        );
        const odds_lay = layOdds?.filter(
          (todd) => todd.ri === item.SelectionId
        );
        const old_back = oldBack?.filter(
          (todd) => todd.ri === item.SelectionId
        );
        const old_lay = oldLay?.filter((todd) => todd.ri === item.SelectionId);
        let disabelBack = "lockBackBets" in item ? item?.lockBackBets : false;
        let disabelLay = "lockLayBets" in item ? item?.lockLayBets : false;
        let disableFull = checkArrays(
          odds_back?.slice(0, 1),
          odds_lay?.slice(0, 1),
          localLimit
        );
        let showPosition =
          (isNumber(item?.position) &&
            position?.length > 0 &&
            Math.abs(item?.position) > 0) ||
          (Math.abs(item?.newPosition) >= 0 &&
            showBetDialog &&
            betSlipObject?.playType == typeGame &&
            marketId == betSlipObject?.object?.newMarketId);

        return (
          <Fragment>
            <dl
              id="selection_247650_0_00"
              className="bets-selections"
              style={{ display: "flex" }}
            >
              <dt>
                <h4 id="runnerName"> {item?.RunnerName || item?.runnerName}</h4>
                {showPosition && (
                  <ul id="winLoss">
                    {isNumber(item?.position) &&
                      position?.length > 0 &&
                      Math.abs(item?.position) > 0 && (
                        <li
                          id="withoutBet"
                          className={item?.position > 0 ? "win" : "lose"}
                        >
                          {isNumber(item?.position) &&
                            Math.abs(item?.position) > 0
                            ? item?.position > 0
                              ? Math?.abs(item?.position).toFixed(2)
                              : `(${Math.abs(item?.position).toFixed(2)})`
                            : ""}
                        </li>
                      )}
                    {Math.abs(item?.newPosition) >= 0 &&
                      showBetDialog &&
                      betSlipObject?.playType == typeGame &&
                      marketId == betSlipObject?.object?.newMarketId && (
                        <li
                          id="withBet"
                          className={`to-${item?.newPosition > 0 ? "win" : "lose"
                            }`}
                        >
                          {item?.newPosition > 0
                            ? Math.abs(item?.newPosition).toFixed(2)
                            : `(${Math.abs(item?.newPosition).toFixed(2)})`}
                        </li>
                      )}
                  </ul>
                )}
              </dt>

              <RenderOddsSky
                component={typeGame}
                index={index}
                marketName={marketName}
                item={item}
                disabelBack={disabelBack}
                oldBack={old_back}
                oldLay={old_lay}
                disableFull={disableFull}
                disabelLay={detail?.market == "Win" ? true : disabelLay}
                isInPlay={
                  ["Win", "Winner"].includes(detail?.market)
                    ? true
                    : detail?.status == "in_play"
                      ? true
                      : false
                }
                handelChange={handelChange}
                odds_lay={odds_lay}
                odds_back={odds_back}
                limit={localLimit}
                ms={ms}
                betType={betSlipObject?.betType}
                active={
                  showBetDialog &&
                  marketId == betSlipObject?.newMarketId &&
                  item?.SelectionId == betSlipObject?.object?.SelectionId &&
                  typeGame == betSlipObject?.playType
                }
              />
            </dl>
            {showBetDialog &&
              betSlipObject?.playType == typeGame &&
              marketId == betSlipObject?.object?.newMarketId &&
              betSlipObject?.object?.SelectionId == item?.SelectionId && (
                <BetSlipSky />
              )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default React.memo(SelectionSky);
